export default __webpack_public_path__ + "static/media/brown.0073cbb9.jpg";